export const TARGET_COMMENT_ID_QUERY_PARAM = 'commentId'
